import { LOGIN_SET_IS_LOADING } from "../constants";
import { get } from "../Services/http";



const setLoginFormLoading = (isLoading: boolean) => ({
  type: LOGIN_SET_IS_LOADING,
  payload: {
    isLoading,
  },
});

export const performVippsLoginAction = (e?: any) => (dispatch) => {
  dispatch(setLoginFormLoading(true));

  get('/api/vipps/login')
    .then(response => {
      if (!response.ok) {
        console.error(`HTTP error! Status: ${response.status}`);
      }
      return response.text();
    })
    .then((url) => {
      window.location.replace(url);
    })
    .catch((error) => {
      console.error('Error during Vipps login:', error);
    })
    .finally(() => {
      dispatch(setLoginFormLoading(false));
    });
};

export const performVippsRegisterAction = (e?: any) => (dispatch) => {
  dispatch(setLoginFormLoading(true));

  get('/api/vipps/register')
  .then(response => {
    if(!response.ok){
        console.error(`HTTP error! Status: ${response.status}`);
    }
    return response.text()
  })
  .then(url => {window.location.replace(url)})
  .catch((error) => {
    console.error('Error during Vipps register:', error)
  })
  .finally(() => {
    dispatch(setLoginFormLoading(false))
  })
};